import { State } from "../../../state";
import { ApplyActionVisibility } from "../_CostsAndOutcomes/ApplyActionVisibility";
import { ApplyCosts } from "../_CostsAndOutcomes/ApplyCosts";
import { ApplyCostScaleChange } from "../_CostsAndOutcomes/ApplyCostScaleChange";
import { ApplyOutcomes } from "../_CostsAndOutcomes/ApplyOutcomes";
import { meetsCostRequirements } from "../_CostsAndOutcomes/meetsCostRequirements";
import { applyAchievementChecks } from "../../../Achievements/checkAchievements";

export const IncreaseCapacity3023 = (actionId: string, state: State) => {
  const newBricks = new Map(state.bricks);
  const newActions = new Map(state.actions);
  const newActionTimestamps = state.actionTimestamps;
  const newActionsTriggeredByType = state.actionsTriggeredByType;

  const action = new Map(state.actions).get(actionId)!;

  // Check if action meets cost requirements
  if (!meetsCostRequirements(action, newBricks)) return state;

  // Apply Action Visibility
  const { newActions: updatedActions, newActionOrder } = ApplyActionVisibility(
    action,
    newActions,
    state.actionOrder,
  );

  // Apply Costs
  // null = result of applied costs are negative.  Should be caught during meetCostRequirements
  if (ApplyCosts(action, newBricks, newActionTimestamps) === null) return state;

  // Apply Outcomes
  // null = default case was triggered
  if (ApplyOutcomes(action, newBricks, newActionTimestamps) === null)
    return state;

  // Apply Increase in costScale
  ApplyCostScaleChange(action, updatedActions);

  // Apply Acheivement Data
  const newActionsAmt = newActionsTriggeredByType.get(actionId) ?? 0;
  newActionsTriggeredByType.set(actionId, newActionsAmt + 1);

  const newState = {
    ...state,
    actionTimestamps: newActionTimestamps,
    bricks: newBricks,
    actions: updatedActions,
    actionOrder: newActionOrder,
    totalActionsTriggered: state.totalActionsTriggered + 1,
    actionsTriggeredByType: newActionsTriggeredByType,
  };

  return applyAchievementChecks(newState);
};
